import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
// 1. 创建动画上下文
const AnimationContext = createContext();

export const AnimationProvider = ({ children }) => {
  const [dots, setDots] = useState([]);
  const targetRef = useRef(null);

  const triggerAnimation = (startX, startY) => {
    if (!targetRef.current) return;

    // 动态获取最新目标位置
    const targetRect = targetRef.current.getBoundingClientRect();
    const endX = targetRect.left + targetRect.width / 2;
    const endY = targetRect.top + targetRect.height / 2;

    // 使用更可靠的唯一标识符
    const newDot = {
      id: uuidv4(), // 或使用 Date.now() + Math.random()
      startX,
      startY,
      endX,
      endY
    };

    setDots(prev => [...prev, newDot]);
  };

  return (
    <AnimationContext.Provider value={{ triggerAnimation, targetRef }}>
      {children}
      {/* 渲染所有飞行粒子 */}
      {dots.map(dot => (
        <FlyingDot
          key={dot.id}  // 确保唯一key
          {...dot}
          onComplete={() => setDots(prev => prev.filter(d => d.id !== dot.id))}
        />
      ))}
    </AnimationContext.Provider>
  );
};

// 飞行粒子组件（优化版）
const FlyingDot = ({ startX, startY, endX, endY, onComplete }) => {
  const dotRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    if (!dot) return;

    // 重置初始状态
    dot.style.transform = 'translate(0, 0)';
    dot.style.opacity = '1';

    // 计算贝塞尔曲线控制点
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const controlX = startX + deltaX / 2;
    const controlY = startY + deltaY / 2 - Math.min(Math.abs(deltaY), 200); // 控制弧度高度

    // 创建贝塞尔曲线动画
    dot.animate([
      {
        transform: 'translate(0, 0)',
        offset: 0,
        opacity: 1
      },
      {
        transform: `translate(${deltaX}px, ${deltaY}px)`,
        offset: 1,
        opacity: 0
      }
    ], {
      duration: 1500, // 增加飞行时间到1.5秒
      easing: `cubic-bezier(0.4, 0, 0.2, 1)`, // 平滑的贝塞尔曲线
      fill: 'forwards'
    }).onfinish = () => {
      onComplete();
    };

    // 添加超时保险
    const fallbackTimer = setTimeout(onComplete, 2000);
    
    return () => {
      clearTimeout(fallbackTimer);
    };
  }, [endX, endY, startX, startY, onComplete]);

  return (
    <div
      ref={dotRef}
      className="w-4 h-4 bg-neutral rounded-full fixed pointer-events-none"
      style={{
        left: `${startX}px`,
        top: `${startY}px`,
        opacity: 1
      }}
    />
  );
};

// 自定义 hook（保持不变）
export const useAnimation = () => useContext(AnimationContext);